import MainContent from '../../../layouts/maincontent/MainContent';
import Lottie from 'react-lottie';
import wifi from '../../../lotties/wifi.json';
import styleNoConnection from './NoConnection.module.css';
function NoConnection() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    speed: 1,
    animationData: wifi,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };
  return (
    <MainContent>
      <section className={ styleNoConnection["noConnection-section"] }>
        <div className="container">
          <div className="row justify-content-center pt-5">
            <div className="col-md-5">
              <div className={ `card ${styleNoConnection["card"]}` }>
                <div className="text-center pt-5">
                  <Lottie
                    width='50%'
                    options={ defaultOptions }
                  />
                </div>
                <div className={ `${styleNoConnection["card-body"]} card-body` }>
                  <h1 className={ `${styleNoConnection.order_message} text-center mt-5 fw-bolder` }>توجد مشكلة إتصال بالانترنت</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section >
    </MainContent >
  );
};

export default NoConnection;